const globalmeta = {
    siteName: "ReScribe",
    siteUrl: "https://app.rescribe.ai",
    siteLogo: "/favicon.ico",
    email: "hello@rescribe.ai",
    description: "Write better copy. Everywhere."
}

export default globalmeta;